var radius = 100
var fields = $('.round_diagramm #circle'),
  container = $('.round_diagramm'),
  width = container.width(),
  height = container.height()
var angle = 0,
  step = (2 * Math.PI) / fields.length
fields.each(function () {
  var x = Math.round(width / 2 + radius * Math.cos(angle) - $(this).width() / 2)
  var y = Math.round(
    height / 2 + radius * Math.sin(angle) - $(this).height() / 2
  )
  $(this).css({
    left: x + 'px',
    top: y + 'px',
  })
  angle += step
})

$('.counter').each(function () {
  var $this = $(this),
    countTo = $this.attr('data-count')
  $({ countNum: $this.text() }).animate(
    {
      countNum: countTo,
    },
    {
      duration: 3000,
      easing: 'linear',
      step: function () {
        $this.text(Math.floor(this.countNum))
      },
      complete: function () {
        $this.text(this.countNum)
      },
    }
  )
})
